import React from 'react';
import { Col, Radio, Row, Tag } from 'antd';
import style from './style.less';

const FadedCard = ({
  data,
  value,
  onChangeFunction,
  selectedProtectionLevel,
  xrayEnabledCloudProviders,
}) => {
  const { title, description, subDescription, key } = data;

  let message = '';
  const isXrayValid = xrayEnabledCloudProviders.includes(value.toLowerCase());

  if (!isXrayValid) {
    message = 'Coming Soon';
    selectedProtectionLevel = 'basic';
  }

  const isDisabled = !isXrayValid && key === 'advanced';

  return (
    <Row
      onClick={() => onChangeFunction('protectionLevel', isXrayValid ? key : 'basic')}
      style={{
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      }}
      className={isDisabled ? style.disabledCard : style.cardMain}
    >
      <Col span={2}>
        <Radio.Group
          onChange={e => onChangeFunction('protectionLevel', e.target.value)}
          value={selectedProtectionLevel}
        >
          <Radio disabled={isDisabled} value={key} />
        </Radio.Group>
      </Col>
      <Col span={22}>
        <div className={style.headerContainer}>
          <h6 className={style.title}>
            {isXrayValid && key === 'advanced'
              ? title
              : key === 'advanced'
              ? 'ADVANCED'
              : 'BASIC (CloudEye)'}
          </h6>
          {isDisabled && <Tag color="#3AA0FF">{message}</Tag>}
        </div>
        <p dangerouslySetInnerHTML={{ __html: description }} />
        <p dangerouslySetInnerHTML={{ __html: subDescription }} className={style.subDescription} />
      </Col>
    </Row>
  );
};

export default FadedCard;
